import { render } from "./Bse.vue?vue&type=template&id=697aed8f"
import script from "./Bse.vue?vue&type=script&lang=js"
export * from "./Bse.vue?vue&type=script&lang=js"

import "./Bse.vue?vue&type=style&index=0&id=697aed8f&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__